import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';

import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import {LeistungProvider} from '../../providers/leistung/leistung';

import { ProjectassignmentPage } from '../projectassignment/projectassignment';

/**
 * Generated class for the ProjectsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-projects',
  templateUrl: 'projects.html',
})
export class ProjectsPage {
  Projekte = [];
  loading: any;
  mode = {create:true};

  constructor(public navCtrl: NavController, 
  	public navParams: NavParams, 
  	private rhynoApi: RhynoApiProvider,
    public loadingCtrl: LoadingController,
  	public leistungCtrl: LeistungProvider) {

    this.mode = navParams.data;

		this.getData();

  }
  doRefresh(refresher){
    this.getData();
    refresher.complete();
  }
  getData(){
    this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();

    this.rhynoApi.getProjektAll().subscribe(
      data => {
      if (data.success){
        this.Projekte = data.data; 
        console.log(data);
      }
      this.loading.dismiss();
    },
      err => {
      console.log(err);
      this.loading.dismiss();
    },
    () => console.log('Projekte Search Complete')
    );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectProjectPage');
  }
  select(data){
  	this.navCtrl.push(ProjectassignmentPage, {create:true, data: data});
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/projects.ts